import React from 'react';
import { Loading as Indicator } from '@moda/om';
import './Loading.scss';

export const Loading: React.FC = () => <Indicator className="Loading--absolute" />;
